import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  FormControlLabel,
  IconButton,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  useMediaQuery,
} from "@mui/material";
import {
  TIPO_FORMAS_PAGAMENTO,
  TIPO_FORMAS_PAGAMENTO_ONLINE,
} from "../payments.config";
import { useTheme } from "@emotion/react";
const TableFormaDePagamento = ({
  formaDePagamentos,
  page,
  rowsPerPage,
  handleClickOpenEdit,
  handleChangePage,
  handleChangeRowsPerPage,
  actives,
  setActives,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Paper>
      <Box p={3}>
        <Box
          display="flex"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ mb: "1rem", ml: "0.5rem" }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={actives}
                onChange={() => {
                  setActives(!actives);
                }}
              />
            }
            label={
              actives
                ? "Formas de pagamentos ativas"
                : "Formas de pagamentos inativas"
            }
          />
        </Box>

        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell align="left">Descrição</TableCell>
                <TableCell align="left">Tipo</TableCell>
                <TableCell align="left">Situação</TableCell>
                <TableCell align="right"></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {formaDePagamentos
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((fp) => {
                  return (
                    <TableRow key={fp.id}>
                      <TableCell align="left">
                        {fp.descricao.toUpperCase()}
                      </TableCell>
                      <TableCell align="left">
                        {!fp.tipoPagamento || fp.tipoPagamento === "local"
                          ? TIPO_FORMAS_PAGAMENTO.find(
                              (e) => e.value === fp.tipo
                            ).label
                          : TIPO_FORMAS_PAGAMENTO_ONLINE.find(
                              (e) => e.value === fp.tipo
                            ).label}
                      </TableCell>
                      <TableCell align="left">
                        {fp.ativo ? "Ativo" : "Inativo"}
                      </TableCell>
                      <TableCell scope="medium" align="right" xs={1} sm={2}>
                        {!isMobile ? (
                          <Button
                            onClick={(event) => {
                              handleClickOpenEdit(fp);
                            }}
                            startIcon={<EditIcon />}
                          >
                            Editar
                          </Button>
                        ) : (
                          <IconButton
                            onClick={(event) => {
                              handleClickOpenEdit(fp);
                            }}
                            size="small"
                            color="primary"
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={formaDePagamentos.length}
            labelRowsPerPage="Linhas por página"
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      </Box>
    </Paper>
  );
};

export default TableFormaDePagamento;
